<!--
 * @Description:Modal 实现挂载在子应用里面
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-08 09:53:53
 * @LastEditors: mdb
-->
<template>
  <a-modal v-bind="$attrs" @cancel="cancael">
    <DcPenetrateContent>
      <slot></slot>
    </DcPenetrateContent>
    <template #footer>
      <slot name="footer">
        <a-button @click="cancael">{{ cancelText || t('btn.cancel') }}</a-button>
        <a-button type="primary" :loading="confirmLoading" v-if="!hideOk" @click="submit">{{
          okText || t('btn.confirm')
        }}</a-button>
      </slot>
    </template>
  </a-modal>
</template>
<script lang="ts">
import { useI18n } from 'vue-i18n'
export default { name: 'CosModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()

defineProps({
  hideOk: {
    type: Boolean,
    default: false
  },
  okText: {
    type: String
  },
  cancelText: {
    type: String
  },
  confirmLoading: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['ok', 'cancel', 'update:visible'])
const submit = () => {
  emit('ok')
}
const cancael = () => {
  emit('cancel')
  emit('update:visible', false)
}
</script>
